<template>
    <div>
        <barraprincipalpsp @abrir="mtMenuVisible"/>    
        <menulateral @cerrar="mtMenuVisible" :value="menuVisible"> </menulateral>  
        <v-container fluid>
            <div class="claro elevation-5">
                <v-row dense>     
                    <v-col cols="12" md="12" class="d-flex align-center px-4">
                        <h2 class="primary--text">Mi perfil.</h2>                    
                    </v-col>                    
                </v-row>
            </div>      

            <br>  
            
            <div>                 

                <div class="elevation-4 pa-3 mt-2">
                    <v-row>
                        <v-col cols="12">
                            <span class="subtitle-2">Datos generales</span>
                        </v-col>
                    </v-row>
    
                    <v-row dense>
                        <v-col cols="12" sm="12" md="3" >
                            <v-text-field v-model="nombre" label="Nombre" :rules="[rules.required]" dense outlined autofocus></v-text-field>
                        </v-col>
            
                        <v-col cols="12" sm="12" md="3">
                            <v-text-field v-model="apellido_paterno" label="Apellido Paterno" :rules="[rules.required]" dense outlined></v-text-field>
                        </v-col>
    
                        <v-col cols="12" sm="12" md="3">
                            <v-text-field v-model="apellido_materno" label="Apellido Materno" :rules="[rules.required]" dense outlined></v-text-field>
                        </v-col>
                    </v-row> 
                   
                
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="telefono" label="Teléfono" :rules="[rules.required]" dense outlined></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="curp" label="CURP" :rules="[rules.required, rules.max18]" maxlength="18" outlined dense></v-text-field>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_curp_comprobante == 0">
                            <v-file-input v-model="curp_comprobante" label="CURP" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" v-if="bandera_curp_comprobante == 0">
                            <v-btn outlined dense color="primary" title="Enviar archivo" @click="subirArchivo('curp', curp_comprobante)" v-if="curp_comprobante != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="3" v-if="bandera_curp_comprobante == 1 || bandera_curp_comprobante == 2 || bandera_curp_comprobante == 3" >
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('curp')">CURP <v-icon class="ml-2">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_curp_comprobante == 1 || bandera_curp_comprobante == 3" class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('curp')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>
                        
                    </v-row>
                </div>


                <div class="elevation-4 pa-3 mt-2">
                    <v-row>
                        <v-col cols="12">
                            <span class="subtitle-2">Documentos académicos</span>
                        </v-col>
                    </v-row>               

                    <v-row dense>
                        <v-col cols='12' class="primary--text"><b>Licenciatura</b></v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="10" sm="4" v-if="bandera_lic_certificado == 0">
                            <v-file-input v-model="lic_certificado" label="Certificado" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" v-if="bandera_lic_certificado == 0">
                            <v-btn outlined dense color="primary" @click="subirArchivo('lic_certificado', lic_certificado)" v-if="lic_certificado != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_lic_certificado == 1 || bandera_lic_certificado == 2 || bandera_lic_certificado == 3">
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('lic_certificado')">Certificado <v-icon class="ml-3">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_lic_certificado == 1 || bandera_lic_certificado == 3 " class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('lic_certificado')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_lic_cedula == 0">
                            <v-file-input v-model="lic_cedula" label="Cédula" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" v-if="bandera_lic_cedula == 0">
                            <v-btn outlined dense color="primary" @click="subirArchivo('lic_cedula', lic_cedula)" v-if="lic_cedula != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_lic_cedula == 1 || bandera_lic_cedula == 2 || bandera_lic_cedula == 3">
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('lic_cedula')">Cédula  <v-icon class="ml-3">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_lic_cedula == 1 || bandera_lic_cedula == 3 " class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('lic_cedula')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>
                    </v-row>      

                    <v-row dense>
                        <v-col cols='12' class="primary--text"><b>Maestría</b></v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="10" sm="4" v-if="bandera_mae_certificado == 0">
                            <v-file-input v-model="mae_certificado" label="Certificado" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" v-if="bandera_mae_certificado == 0">
                            <v-btn outlined dense color="primary" @click="subirArchivo('mae_certificado', mae_certificado)" v-if="mae_certificado != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_mae_certificado == 1 || bandera_mae_certificado == 2 || bandera_mae_certificado == 3">
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('mae_certificado')">Certificado <v-icon class="ml-3">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_mae_certificado == 1 || bandera_mae_certificado == 3 " class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('mae_certificado')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_mae_cedula == 0">
                            <v-file-input v-model="mae_cedula" label="Cédula" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" v-if="bandera_mae_cedula == 0">
                            <v-btn outlined dense color="primary" @click="subirArchivo('mae_cedula', mae_cedula)" v-if="mae_cedula != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_mae_cedula == 1 || bandera_mae_cedula == 2 || bandera_mae_cedula == 3">
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('mae_cedula')">Cédula  <v-icon class="ml-3">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_mae_cedula == 1 || bandera_mae_cedula == 3 " class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('mae_cedula')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>
                    </v-row>      

                    <v-row dense>
                        <v-col cols='12' class="primary--text"><b>Doctorado</b></v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="10" sm="4" v-if="bandera_doc_certificado == 0">
                            <v-file-input v-model="doc_certificado" label="Certificado" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" v-if="bandera_doc_certificado == 0">
                            <v-btn outlined dense color="primary" @click="subirArchivo('doc_certificado', doc_certificado)" v-if="doc_certificado != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_doc_certificado == 1 || bandera_doc_certificado == 2 || bandera_doc_certificado == 3">
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('doc_certificado')">Certificado <v-icon class="ml-3">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_doc_certificado == 1 || bandera_doc_certificado == 3 " class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('doc_certificado')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_doc_cedula == 0">
                            <v-file-input v-model="doc_cedula" label="Cédula" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" v-if="bandera_doc_cedula == 0">
                            <v-btn outlined dense color="primary" @click="subirArchivo('doc_cedula', doc_cedula)" v-if="doc_cedula != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_doc_cedula == 1 || bandera_doc_cedula == 2 || bandera_doc_cedula == 3">
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('doc_cedula')">Cédula  <v-icon class="ml-3">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_doc_cedula == 1 || bandera_doc_cedula == 3 " class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('doc_cedula')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>
                    </v-row>      

                </div>     

                <div class="elevation-4 pa-3 mt-2">
                    <v-row>
                        <v-col cols="12">
                            <span class="subtitle-2">Dirección</span>
                        </v-col>
                    </v-row>
    
                    <v-row dense>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="dir_calle" label="Calle" :rules="[rules.required]" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field v-model="dir_numero" label="Número" :rules="[rules.required]" dense outlined></v-text-field>
                        </v-col>
                    </v-row>
    
                    <v-row dense>
                        <v-col cols="12" sm="5">
                            <v-text-field v-model="dir_colonia" label="Colonia" :rules="[rules.required]" dense outlined></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="5">
                            <v-text-field v-model="dir_ciudad" label="Ciudad" :rules="[rules.required]" dense outlined></v-text-field>
                        </v-col>
                    </v-row>
    
                    <v-row dense>
                        <v-col cols="10" sm="4" v-if="bandera_dir_comprobante == 0">
                            <v-file-input v-model="dir_comprobante" label="Comprobante de domicilio" prepend-icon="" append-icon="mdi-cloud-upload"  dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" v-if="bandera_dir_comprobante == 0">
                            <v-btn outlined dense color="primary" @click="subirArchivo('domicilio', dir_comprobante)" v-if="dir_comprobante != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="12" sm="5" v-if="bandera_dir_comprobante == 1 || bandera_dir_comprobante == 2 || bandera_dir_comprobante == 3">
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('domicilio')">Comprobante domicilio <v-icon class="ml-2">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_dir_comprobante == 1 || bandera_dir_comprobante == 3" class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('domicilio')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>
                    </v-row>
                </div>
                
                <div class="elevation-4 pa-3 mt-2">
                    <v-row>
                        <v-col>
                            <span class="subtitle-2">Tipo de contrato</span>
                        </v-col>
                    </v-row>
                    
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-select v-model="tipo_contrato" label="Tipo" :items="catalogo_contrato_tipos"  dense outlined></v-select>
                        </v-col>                        
                    </v-row>    
                    
                </div>


                <div class="elevation-4 pa-3 mt-2">
                    <v-row>
                        <v-col cols="12">
                            <span class="subtitle-2">Datos fiscales</span>
                        </v-col>
                    </v-row>      

                    <v-row dense>
                        <v-col cols="12">
                            <v-checkbox v-model="es_resico" label="Soy RESICO"></v-checkbox>
                        </v-col>    
                    </v-row>         
    
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="rfc" label="RFC" :rules="[rules.required, rules.max13]" maxlength="13" dense outlined></v-text-field>
                        </v-col>
    
                        <v-col cols="10" sm="4" v-if="bandera_rfc_comprobante == 0">
                            <v-file-input v-if="tipo_contrato == 'honorarios'" v-model="rfc_comprobante" label="Cédula fiscal" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                            <v-file-input v-if="tipo_contrato == 'asimilados'" v-model="rfc_comprobante" label="Último talón de pago" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1" v-if="bandera_rfc_comprobante == 0">
                            <v-btn outlined dense color="primary" @click="subirArchivo('rfc', rfc_comprobante)" v-if="rfc_comprobante != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="4" v-if="bandera_rfc_comprobante == 1 || bandera_rfc_comprobante == 2 || bandera_rfc_comprobante == 3">
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('rfc')">{{text_boton_documento_fiscal}}  <v-icon class="ml-3">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_rfc_comprobante == 1 || bandera_rfc_comprobante == 3" class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('rfc')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>
                    </v-row>      
                </div>                         
        
                
                <div class="elevation-4 pa-3 mt-2">
                    <v-row>
                        <v-col>
                            <span class="subtitle-2">Datos bancarios</span>
                        </v-col>
                    </v-row>
                    
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-select v-model="banco_nombre" label="Banco" :items="catalogo_bancos"  dense outlined></v-select>
                        </v-col>
                        <v-col cols="12" sm="2">
                            <v-text-field v-model="banco_sucursal" label="Sucursal" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="banco_cuenta" label="No. Cuenta" dense outlined></v-text-field>
                        </v-col>
                    </v-row>
    
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model="banco_clabe" label="Cuenta CLABE" :rules="[rules.max18]" maxlength="18" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3">
                            <v-text-field v-model="banco_tarjeta" label="No. Tarjeta" maxlength="18" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="10" sm="4"  v-if="bandera_banco_caratula == 0">
                            <v-file-input v-model="banco_caratula" label="Carátula bancaria" prepend-icon="" append-icon="mdi-cloud-upload" dense outlined></v-file-input>
                        </v-col>
                        <v-col cols="1" sm="1"  v-if="bandera_banco_caratula == 0">
                            <v-btn outlined dense color="primary" @click="subirArchivo('banco', banco_caratula)" v-if="banco_caratula != null"> <v-icon>mdi-send</v-icon> </v-btn>
                        </v-col>

                        <v-col cols="10" sm="3" v-if="bandera_banco_caratula == 1 || bandera_banco_caratula == 2 || bandera_banco_caratula == 3">
                            <v-btn dense color="primary" title="Descargar archivo" dark @click="descargarArchivo('banco')">Carátula<v-icon class="ml-2">mdi-download</v-icon></v-btn>
                            <v-btn v-if="bandera_banco_caratula == 1 || bandera_banco_caratula == 3" class="ml-2" dense color="secondary" title="Eliminar archivo" @click="eliminarArchivo('banco')" dark> <v-icon>mdi-delete</v-icon> </v-btn>
                        </v-col>
                    </v-row>
                </div>

                <div class="elevation-4 pa-3 mt-2">
                    <v-row>
                        <v-col>
                            <span class="subtitle-2">Tipo de personal</span>
                        </v-col>
                    </v-row>
                    
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-select v-model="tipo_personal" label="Tipo" :items="catalogo_personal_tipos"  dense outlined></v-select>
                        </v-col>                        
                    </v-row>    
                    
                </div>

                <br>
                <v-row>
                    <v-col cols="12" sm="12" class="d-flex justify-end">
                        <v-btn dense color="primary" @click="validacionDatos()" :loading="registrando" dark>Guardar</v-btn>
                    </v-col>                                       
                </v-row>   
                
            </div>
    
            <v-snackbar v-model="snackbar" :color="snackbarcolor" light >
                <div class="d-flex justify-center"><strong>{{snackbartexto}}</strong></div>
            </v-snackbar>    

            <v-dialog max-width="300" v-model="dialogo">
                <v-card>
                    <v-card-text>
                        <div class="d-flex justify-center"><b>Enviando archivo</b></div>
                        <div><v-progress-linear indeterminate color="primary"></v-progress-linear></div>
                        <div class="d-flex justify-center">{{porcentaje_subido}}</div>
                    </v-card-text>
                </v-card>    
            </v-dialog>    

            <dialogoconfirmacion ref="dialogoconfirmacion"></dialogoconfirmacion>            

            <v-dialog v-model="dlgdocumentacion" max-width='600px'>
                <v-card color="warning">
                    <v-card-title> <v-icon color="black" class="mr-4">mdi-alert</v-icon> Alerta</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" class="title black--text">
                                Es necesario agregar toda la documentación solicitada.
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-end">
                        <v-btn @click="dlgdocumentacion = false" dense color="error"> Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dlgdocumentacionrechazados" max-width='600px'>
                <v-card color="error">
                    <v-card-title> <v-icon color="black" class="mr-4">mdi-alert</v-icon>Alerta</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" class="title black--text">
                                Algunos documentos fueron rechazados
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="black--text">
                                <b>Elimine el documento enviado y adjunte el nuevo documento correcto.</b>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="black--text">
                                Documentos rechazados:
                            </v-col>
                        </v-row>

                        <v-row dense>
                            <v-col cols="12" class="black--text"><span class="pl-6" v-if="bandera_curp_comprobante == 3">- CURP</span></v-col>
                            <v-col cols="12" class="black--text"><span class="pl-6" v-if="bandera_dir_comprobante == 3">- Comprobante de domicilio</span></v-col>
                            <v-col cols="12" class="black--text" v-if="this.tipo_contrato == 'asimilados' && this.bandera_rfc_comprobante == 3"><span class="pl-6">- Último talón de pago</span></v-col>
                            <v-col cols="12" class="black--text" v-if="this.tipo_contrato == 'honorarios' && this.bandera_rfc_comprobante == 3" ><span class="pl-6">- RFC</span></v-col>
                            <v-col cols="12" class="black--text" v-if="this.bandera_banco_caratula == 3"><span class="pl-6">- Caratula datos bancarios</span></v-col>
                            
                            <v-col cols="12" class="black--text" v-if="bandera_lic_certificado == 3"><span class="pl-6">- Certificado de licenciatura</span></v-col>
                            <v-col cols="12" class="black--text" v-if="bandera_lic_cedula == 3"><span class="pl-6">- Cédula de licenciatura</span></v-col>
                            <v-col cols="12" class="black--text" v-if="bandera_mae_certificado == 3"><span class="pl-6">- Certificado de maestría</span></v-col>
                            <v-col cols="12" class="black--text" v-if="bandera_mae_cedula == 3"><span class="pl-6">- Cédula de maestría</span></v-col>
                            <v-col cols="12" class="black--text" v-if="bandera_doc_certificado == 3"><span class="pl-6">- Certificado de doctorado</span></v-col>
                            <v-col cols="12" class="black--text" v-if="bandera_doc_cedula == 3"><span class="pl-6">- Cédula de doctorado</span></v-col>
                        </v-row>


                    </v-card-text>
                    <v-card-actions class="d-flex justify-end">
                        <v-btn @click="dlgdocumentacionrechazados = false" dense color="primary"> Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-container>
    </div>
</template>



<script>

import barraprincipalpsp from '@/components/BarraPrincipalPSP'
import dialogoconfirmacion from '@/components/DialogoConfirmacion'
import menulateral from '@/components/MenuLateralPSP'

export default {

    components:{
        dialogoconfirmacion,
        barraprincipalpsp,
        menulateral
    },
   
    data() {        

        return {        
            
            menuVisible: false,

            snackbartexto: "",
            snackbar: false,            
            snackbarcolor: "",

            dlgdocumentacion: false,
            dlgdocumentacionrechazados: false,

            nombre:"",
            apellido_paterno:"",
            apellido_materno:"",
            telefono:"",
            dir_calle: '',
            dir_numero: '',
            dir_colonia: '',
            dir_ciudad: '',
            dir_comprobante: null,
            bandera_dir_comprobante: 0,

            rfc: '',
            rfc_comprobante: null,
            bandera_rfc_comprobante: 0,
            es_resico: false,

            curp: '',
            curp_comprobante: null,
            bandera_curp_comprobante: 0,

            //Documentos academicos
            lic_certificado: null,
            bandera_lic_certificado: 0,
            lic_cedula: null,
            bandera_lic_cedula: 0,

            mae_certificado: null,
            bandera_mae_certificado: 0,
            mae_cedula: null,
            bandera_mae_cedula: 0,

            doc_certificado: null,
            bandera_doc_certificado: 0,
            doc_cedula: null,
            bandera_doc_cedula: 0,

            tipo_personal: '',
            tipo_contrato: 'honorarios',
            text_boton_documento_fiscal: 'RFC',

            banco_nombre: '',
            banco_sucursal: '',
            banco_cuenta: '',
            banco_tarjeta: '',
            banco_clabe: '',
            banco_caratula: null,
            bandera_banco_caratula: 0,


            catalogo_bancos: [],
            catalogo_personal_tipos: [],
            catalogo_contrato_tipos: [{text:'Por honorarios', value:'honorarios'}, {text:'Asimilados', value:'asimilados'}],
                        
            porcentaje_subido: "",
            dialogo: false,

            rules:{
                required: value => !!value || 'Campo requerido',
                max13: value => value.length == 13 || '13 caracteres',                
                max18: value => value.length == 18 || '18 caracteres',                
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Correo no valido'
                },               
            },

            registrando: false,

        }
    },

    watch: {           
        nombre(){
            this.nombre = this.nombre.charAt(0).toUpperCase() + this.nombre.slice(1)
        },
        apellido_paterno(){
            this.apellido_paterno = this.apellido_paterno.charAt(0).toUpperCase() + this.apellido_paterno.slice(1)
        },            
        apellido_materno(){
            this.apellido_materno = this.apellido_materno.charAt(0).toUpperCase() + this.apellido_materno.slice(1)
        },
        curp(){
            this.curp = this.curp.toUpperCase()
        },
        rfc(){
            this.rfc = this.rfc.toUpperCase()
        },
        tipo_contrato(value){
            if(value == 'honorarios')
                this.text_boton_documento_fiscal = 'RFC'
            else    
                this.text_boton_documento_fiscal = 'Último talón de pago'
        }
    },

    beforeCreate() {
        const token = sessionStorage.getItem('dataex')
               
        this.axios.post(this.$url+'/acceso/validatoken/usuario', {}, {headers: {Authorization: `Bearer ${token}`}})     
            .then((response)=>{

                const data = response.data
                
                if(data.codigo == 'lgout')
                    this.$router.push({"name":'PSPLogin'})


                return            
            })
            .catch((error)=>{
                console.log("Error "+error);
            })
        
        
    },

    created(){
        this.getPerfil()
        this.getCatalogoBancos()
        this.getCatalogoPersonalTipos()
    },


    methods: {
        mtMenuVisible(value){
            this.menuVisible = value
        },

        getPerfil(){
            const token = sessionStorage.getItem('dataex')

            this.axios.get(this.$url+"/psp/perfil/informacion", {headers:{"authorization":`Bearer ${token}`}})
                .then((response)=>{
                    let rs = response.data

                    if(rs.error){
                        this.snackbartexto = rs.mensaje
                        this.snackbar = true   
                        this.snackbarcolor = "error"
                    }   
                    else{
                        let pr = rs.perfil

                        this.nombre = pr.nombre,                        
                        this.apellido_paterno = pr.apellido_paterno,
                        this.apellido_materno = pr.apellido_materno,
                        this.telefono = pr.telefono,
                        this.dir_calle = pr.direccion_calle,
                        this.dir_numero = pr.direccion_numero,
                        this.dir_colonia = pr.direccion_colonia,
                        this.dir_ciudad = pr.direccion_ciudad,
                        this.bandera_dir_comprobante = pr.direccion_comprobante,
                        this.rfc = pr.rfc,
                        this.bandera_rfc_comprobante = pr.rfc_comprobante,
                        this.curp = pr.curp,
                        this.bandera_curp_comprobante = pr.curp_comprobante,
                        this.tipo_personal = pr.ctipo_personal,
                        this.banco_nombre = pr.banco_nombre,
                        this.banco_sucursal = pr.banco_sucursal,
                        this.banco_cuenta = pr.banco_cuenta,
                        this.banco_tarjeta = pr.banco_tarjeta,
                        this.banco_clabe = pr.banco_clabe,
                        this.bandera_banco_caratula = pr.banco_caratula
                        //Documentos académicos
                        this.bandera_lic_certificado = pr.lic_certificado
                        this.bandera_lic_cedula = pr.lic_cedula
                        this.bandera_mae_certificado = pr.mae_certificado
                        this.bandera_mae_cedula = pr.mae_cedula
                        this.bandera_doc_certificado = pr.doc_certificado
                        this.bandera_doc_cedula = pr.doc_cedula

                        this.tipo_contrato = pr.tipo_contrato

                        if(pr.es_resico == 'true')
                            this.es_resico = true
                        else
                            this.es_resico = false


                        if(this.bandera_curp_comprobante == 0 || this.bandera_rfc_comprobante == 0 || this.bandera_dir_comprobante == 0 || this.bandera_banco_caratula == 0)
                            this.dlgdocumentacion = true
                        
                        if(this.bandera_curp_comprobante == 3 || this.bandera_rfc_comprobante == 3 || this.bandera_dir_comprobante == 3 || this.bandera_banco_caratula == 3 || this.bandera_lic_certificado == 3 || this.bandera_lic_cedula == 3 || this.bandera_mae_certificado == 3 || this.bandera_mae_cedula == 3 || this.bandera_doc_certificado == 3 || this.bandera_doc_cedula == 3)
                            this.dlgdocumentacionrechazados = true

                        

                    }                           
                    
                })
                .catch(() =>{
                    this.snackbartexto = "Ocurrió un error al actualizar información."
                    this.snackbar = true
                    this.snackbarcolor = "error"
                })
                .finally(()=>{
                    
                })
        },

        getCatalogoBancos(){
            this.axios.get(this.$url+'/catalogos/bancos/listado')
                .then((response)=>{

                    const data = response.data
                    
                    this.catalogo_bancos = []

                    if(!data.error){
                        for(let bn of data.bancos){
                            this.catalogo_bancos.push({value:bn.nombre, text:bn.nombre})
                        }
                    }

                })
                .catch((error)=>{
                    console.log("Error al consultar bancos "+error );
                })
        },

        getCatalogoPersonalTipos(){
            this.axios.get(this.$url+'/catalogos/psptipo/listado')
                .then((response)=>{

                    const data = response.data
                    
                    this.catalogo_personal_tipos = []

                    if(!data.error){
                        for(let tp of data.tipos){
                            this.catalogo_personal_tipos.push({value:tp.clave, text:tp.descripcion})
                        }
                    }

                })
                .catch((error)=>{
                    console.log("Error al consultar bancos "+error );
                })
        },
        
        validacionDatos(){            
            
            if(this.nombre && this.apellido_paterno && this.apellido_materno && this.telefono && this.curp && this.dir_calle && this.dir_numero && this.dir_colonia && this.dir_ciudad && this.rfc ){//Estan todos los datos
                if(this.confirmacion === this.contraseña){ //Confirmación correcta
                    const datos = {
                        nombre: this.nombre.toUpperCase(),
                        apellido_paterno: this.apellido_paterno.toUpperCase(),
                        apellido_materno: this.apellido_materno.toUpperCase(),
                        telefono: this.telefono,
                        curp: this.curp,
                        dir_calle: this.dir_calle.toUpperCase(),
                        dir_numero: this.dir_numero,
                        dir_colonia: this.dir_colonia.toUpperCase(),
                        dir_ciudad: this.dir_ciudad.toUpperCase(),
                        rfc: this.rfc,
                        es_resico: this.es_resico,
                        banco_nombre: this.banco_nombre,
                        banco_sucursal: this.banco_sucursal,
                        banco_cuenta: this.banco_cuenta,
                        banco_clabe: this.banco_clabe,
                        banco_tarjeta: this.banco_tarjeta,
                        tipo_personal: this.tipo_personal,
                        tipo_contrato: this.tipo_contrato
                    }

                    this.actualizarDatos(datos)
                }
                else{
                    this.snackbartexto="Las contraseñas no coinciden."
                    this.snackbar = true
                    this.snackbarcolor = "error"
                }
            }
            else{
                //Faltó algun dato
                this.snackbartexto = "Todos los campos son requeridos."
                this.snackbar = true
                this.snackbarcolor = "error"
            }

        },        

        actualizarDatos(datos){

            const token = sessionStorage.getItem('dataex')

            this.registrando = true
            this.axios.post(this.$url+"/psp/perfil/actualizar", {datos: datos}, {headers:{"authorization":`Bearer ${token}`}})
                .then((response)=>{
                    let rs = response.data

                    if(rs.error){
                        this.snackbartexto = rs.mensaje
                        this.snackbar = true   
                        this.snackbarcolor = "error"
                    }
                    else{
                        this.snackbartexto = "Datos actualizados correctamente"
                        this.snackbar = true
                        this.snackbarcolor = "success"
                    }
                    
                })
                .catch(() =>{
                    this.snackbartexto = "Ocurrió un error al actualizar información."
                    this.snackbar = true
                    this.snackbarcolor = "error"
                })
                .finally(()=>{
                    this.registrando = false
                })

        },

        subirArchivo(tipo, archivo){
          
            if (archivo.type != 'application/pdf' && archivo.type != 'image/jpeg' && archivo.type != 'image/png') {   
            //if (archivo.type != 'application/pdf') {   
                this.snackbartexto = "Tipo de archivo no valido..."
                this.snackbarcolor = 'error'
                this.snackbar = true
                return                   
            }
           

            if( (archivo.size / 1024) > 5120 ){
                this.snackbartexto = "Archivo supera el tamaño maximo 5mb"
                this.snackbarcolor = "error"
                this.snackbar = true
                return
            }

            const token = sessionStorage.getItem('dataex')

            let data = new FormData();
            data.set('enctype', 'multipart/form-data')
            data.append("file", archivo)
            data.append('tipo', tipo)
            data.append('_method', 'PUT')

            this.dialogo = true
            this.axios.put(this.$url+'/psp/perfil/archivos/subir', data,                         
                        {
                            headers: {Authorization: `Bearer ${token}`},
                            onUploadProgress: progressEvent =>{                            
                                this.porcentaje_subido ='Subiendo archivos... '+ Math.round(progressEvent.loaded / progressEvent.total * 100) + "%"                                
                            }
                        }                        
                    )
                .then((response)=>{

                    if(response.data){
                        if(response.data.error){
                            this.snackbar = true;
                            this.snackbarcolor = "error";
                            this.snackbartexto = response.data.mensaje
                        }
                        else{
                            this.snackbar = true;
                            this.snackbarcolor = "success";
                            this.snackbartexto = response.data.mensaje
                            
                            if(tipo == 'domicilio'){
                                this.bandera_dir_comprobante = 1
                            }
                            if(tipo == 'curp'){
                                this.bandera_curp_comprobante = 1
                            }
                            if(tipo == 'rfc'){
                                this.bandera_rfc_comprobante = 1
                            }
                            if(tipo == 'banco'){
                                this.bandera_banco_caratula = 1
                            }
                            if(tipo == 'lic_certificado'){
                                this.bandera_lic_certificado = 1
                            }
                            if(tipo == 'lic_cedula'){
                                this.bandera_lic_cedula = 1
                            }
                            if(tipo == 'mae_certificado'){
                                this.bandera_mae_certificado = 1
                            }
                            if(tipo == 'mae_cedula'){
                                this.bandera_mae_cedula = 1
                            }
                            if(tipo == 'doc_certificado'){
                                this.bandera_doc_certificado = 1
                            }
                            if(tipo == 'doc_cedula'){
                                this.bandera_doc_cedula = 1
                            }

                        }
                    }
                    else{
                        this.snackbar = true;
                        this.snackbar_color = "error";
                        this.snackbar_texto = "Error al subir documentos, intente mas tarde." 
                    }
                })
                .catch(()=>{
                    this.snackbar = true;
                    this.snackbar_color = "error";
                    this.snackbar_texto = "Error al subir documentos, intente mas tarde."                    
                })
                .finally(()=>{
                    this.dialogo = false
                })

        },

        descargarArchivo(tipo){            
            const token = sessionStorage.getItem('dataex')
            const data = {tipo: tipo}

            //Funciona bien en Firefox
            this.axios.post(this.$url+"/psp/perfil/archivos/descargar", {data}, 
                    {
                        headers: {Authorization: `Bearer ${token}`},
                        responseType: 'blob'
                    })
          
                .then((response)=>{  

                    if(response.data.error)
                        return

                    const tipo_contenido = response.headers['content-type']
                    const file = new Blob([response.data], {type:tipo_contenido});                            
                    const fileURL = URL.createObjectURL(file)
                    window.open(fileURL)

                })
                .catch((error)=>{
                    console.log("Descarga archivo "+error);
                })
        },

        async eliminarArchivo(tipo){

            const confirmacion = await this.$refs.dialogoconfirmacion.abrir({
                titulo: '¿Realmente quiere eliminar el archivo?',
                confirmar: 'Si',
                cancelar: 'No'
            })

            if(!confirmacion){
                return
            }


            const token = sessionStorage.getItem('dataex')
            const data = {tipo: tipo}

            //Funciona bien en Firefox
            this.axios.post(this.$url+"/psp/perfil/archivos/eliminar", {data}, {headers: {Authorization: `Bearer ${token}`}})
          
                .then((response)=>{  

                    if(response.data.error){
                        this.snackbartexto = response.data.mensaje
                        this.snackbarcolor = 'red'
                        this.snackbar = true
                    }
                    else{
                        this.snackbartexto = response.data.mensaje
                        this.snackbarcolor = 'success'
                        this.snackbar = true

                        if(tipo == 'domicilio'){
                            this.bandera_dir_comprobante = 0
                        }
                        if(tipo == 'curp'){
                            this.bandera_curp_comprobante = 0
                        }
                        if(tipo == 'rfc'){
                            this.bandera_rfc_comprobante = 0
                        }
                        if(tipo == 'banco'){
                            this.bandera_banco_caratula = 0
                        }
                        if(tipo == 'lic_certificado'){
                            this.bandera_lic_certificado = 0
                        }
                        if(tipo == 'lic_cedula'){
                            this.bandera_lic_cedula = 0
                        }
                        if(tipo == 'mae_certificado'){
                            this.bandera_mae_certificado = 0
                        }
                        if(tipo == 'mae_cedula'){
                            this.bandera_mae_cedula = 0
                        }
                        if(tipo == 'doc_certificado'){
                            this.bandera_doc_certificado = 0
                        }
                        if(tipo == 'doc_cedula'){
                            this.bandera_doc_cedula = 0
                        }
                    }

                })
                .catch((error)=>{
                    console.log("Descarga archivo "+error);
                })
        }        

    },

}
</script>